/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useRef, useState, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { Image, Popover } from 'antd';
import classNames from 'classnames';
import { LinkedInPost, Tweet } from 'Types/ArticleTypes';
import HTMLReactParser, { attributesToProps, domToReact, Element } from 'html-react-parser';
import setImageSize from 'Utils/UtilityFunctions';
import Iframe from 'react-iframe';
import SocialShareIcons from 'Components/share/SocialShareIcons';
import {
  actions,
} from 'Slice/ArticlesSlice';
import { useDispatch } from 'react-redux';
import {
  primaryFont, boxShadow, wLight, maxWidth, retina, wMedium, primaryColor, maxTablet, maxMobile,
} from '../../../Utils/utilsStyle';
import UserSocialInfoCard from './UserSocialInfoCard';
import SkeletonCustom from '../skeleton/SkeletonCustom';
import ShareArticleIcon from '../assets/svgIcons/ShareArticleIcon';

const SocialCardWrapper = styled.div`
  border-radius: 8px !important;
  padding: 0px !important;
  width: 100%;
  background-color: #fff;
  min-width: 100%;
  z-index: 0;
  cursor: pointer;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 6px !important;
  }
  &.heroView {
    display: block;
    box-shadow: ${boxShadow};
    .profile-area {
     min-width:100%;
     min-height: 280px !important;
     width: 100%;
     border-radius: 8px 8px 0px 0px;
     @media all and (max-width: ${maxTablet}) {
      min-height: 160px !important;
     }
      .ant-image{
       width:100%;
       img {
        border-radius: 8px 8px 0px 0px; 
       }
      }
      iframe {
        height: 100%;
        width: 100%;
      }
    }
    .text-area {
      padding:15px;
      margin: 0px;
      min-width: auto;
    }
  }
  .ant-image {
    width: 100%;
    height: 100%;
  }
  .profile-area {
      height: 72px;
      width: 72px;
      border-radius: 10px;
    img {
     width: 100%;
     height: 100%;
     border-radius: 10px;
    }
  }
  .bottom{
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    .time-heading {
      font-size: 14px;
      color: #697882;
      font-weight: ${wLight};
      font-family: ${primaryFont};
      margin-top: 5px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 10px;
      }
    }
  }
  .parser-data-drop {
    margin: 10px 0px;
    font-family: ${primaryFont};
    color:#1C2022;
    white-space: break-spaces;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
  .ant-popover{
    z-index: 0;
    .ant-popover-inner {
      border-radius: 16px;
      .ant-popover-inner-content {
        padding: 0px;
        .teams-share-button {
          &:before {
              width: 16.5px;
              height: 16.5px;
              margin-top: 4px;
              @media all and (max-width: ${maxWidth}) , ${retina} {
              margin-top: 2px;
              }
          }
        }
        svg{
          width: 16px !important;
          height:auto;
          margin-right: 4px;
        }
      }
    }
  }
  .popover-sharing-custom {
    height: 15px;
  }
`;

const SocialListCardWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  min-width: 100%;
  align-items: center;
  cursor: pointer;  
  border-radius: 8px;
  min-height: 117px;
  padding: 16px 22px 16px 0px;
  margin-bottom: 8px;
  box-shadow: ${boxShadow};
  &.imageView {
    display: flex;
  }
  .profile-area {
    height: 85px;
    width: 85px;
    min-width: 85px;
    border-radius: 8px;
    margin-left: 16px;
    @media all and (max-width: ${maxTablet}){
      display: none;
    }
    .ant-image {
      height: 100%;
      width: 100%;
      img {
        border-radius: 8px;
        height: 100%;
      }
    }
    .list-view{
      max-width: 100%;
      max-height: 100%;
    }
  }
  .text-area {
    min-width: calc(100% - 100px);
    padding-left: 16px;
    @media all and (max-width: ${maxTablet}){
      min-width: calc(100% - 0px);
    }
    @media all and (max-width: ${maxMobile}){
      min-width: 100%;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }
    .parser-data-drop {
      font-family: ${primaryFont};
      font-weight: ${wLight};
      font-size: 13px;
      line-height: 18px;
      &.time-heading {
        font-size: 10px;
        line-height: 14.6px;
        color: #697882; 
        margin-top: 10px;
      }
    }
    .ant-popover-inner {
      border-radius: 16px;
      .ant-popover-inner-content {
        padding: 0px;
        .teams-share-button {
          &:before {
              width: 16.5px;
              height: 16.5px;
              margin-top: 4px;
              @media all and (max-width: ${maxWidth}) , ${retina} {
              margin-top: 2px;
              }
          }
        }
        svg{
          width: 16px !important;
          height:auto;
          margin-right: 4px;
        }
      }
    }
    .share-tweet{
      .popover-sharing-custom {
        height: 15px;
      }
    }
    .ant-btn-icon-only {
     &.ant-btn-sm {
      width: 12px;
     }
    }
  }
  `;

const ContentWrapper = styled.div`
  min-width: 238px;
  padding: 10px 15px;
  border-radius: 16px;
  box-shadow: ${boxShadow};
  @media all and (max-width: ${maxWidth}) , ${retina} {
    min-width: 200px;
    border-radius: 10px;
    padding: 14px 18px;
  }
  .heading-popover {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    color: ${primaryColor};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
`;

type Props = {
  heroArticle?: boolean,
  title?: string,
  time: string,
  // likes: string,
  ArticleImage?: string,
  tweetData?: Tweet,
  linkedinData?: LinkedInPost,
  articleWidth?: string,
  articleHeight?: string,
  articleId?: number,
  SocialType?: string,
  url?: string,
  companyId?: number,
  videoUrl?: string,
  listView?: boolean,
  companyName?: string,
} & typeof defaultProps;

const defaultProps = {
  articleHeight: '280',
  articleWidth: '400',
  articleId: 0,
  heroArticle: false,
  ArticleImage: '',
  tweetData: {},
  SocialType: 'tweet',
  title: '',
  linkedinData: {} as LinkedInPost,
  url: '',
  companyId: 0,
  videoUrl: '',
  listView: false,
  companyName: '',
};

const clickHandler = (
  e: React.MouseEvent<HTMLSpanElement, MouseEvent> | React.KeyboardEvent<HTMLSpanElement>,
) => {
  e.stopPropagation();
};

const parser = (input: string) => HTMLReactParser(input, {
  replace: (domNode) => {
    const domElement: Element = domNode as Element;
    if (domElement.name === 'a') {
      domElement.attribs.target = '_blank';
      const props = attributesToProps(domElement.attribs);
      return (
        <span
          onClick={(e) => clickHandler(e)}
          onKeyPress={(e) => clickHandler(e)}
          role="button"
          aria-label="Close"
          tabIndex={0}
        >
          <a {...props}>{domToReact(domElement.children)}</a>
        </span>
      );
    }
    return domElement;
  },
});

const SocialCard = function SocialCard(props: Props) {
  const {
    heroArticle, title, time, ArticleImage, tweetData, SocialType, linkedinData, articleWidth,
    articleHeight, articleId, url, companyId, videoUrl, listView, companyName,
  } = props;

  const [refHeight, setRefHeight] = useState(0);
  const [refWidth, setRefWidth] = useState(0);
  const elementRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const content = (
    <ContentWrapper>
      <h6 className="heading-popover">QuickShare to:</h6>
      <SocialShareIcons
        articleid={articleId}
        title={tweetData.tweet}
        img={ArticleImage}
        entity="article"
        url={tweetData.tweetUrl}
        isTwitter
        tweetBy={tweetData.byTwitterAccountDetails.name}
      />
    </ContentWrapper>
  );

  const openArticle = () => window.open(SocialType === 'tweet' ? tweetData.tweetUrl : url);

  useLayoutEffect(() => {
    if (elementRef && elementRef.current?.clientHeight) {
      setRefHeight(elementRef.current?.clientHeight);
    }
    if (elementRef && elementRef.current?.clientWidth) {
      setRefWidth(elementRef.current?.clientWidth);
    }
  });

  return (
    listView ? (
      <SocialListCardWrapper
        onClick={openArticle}
        onKeyPress={openArticle}
        role="button"
        aria-label="Open article"
        tabIndex={0}
        className={classNames({ imageView: ArticleImage?.length })}

      >
        {
          ArticleImage?.length && videoUrl === '' ? (
            <div
              className="profile-area"
              style={{
                position: 'relative',
              }}
            >
              {ArticleImage.includes('.gif') ? <img src={ArticleImage} alt="Social Card " className="list-view" />
                : (
                  <Image
                    preview={false}
                    src={setImageSize(
                      ArticleImage,
                      85,
                      85,
                      articleId,
                    )}
                    alt="Social Card "
                  />
                )}
            </div>
          ) : null
        }
        {
          videoUrl?.length && ArticleImage?.length
            ? (
              <div
                className="profile-area"
                style={{
                  position: 'relative',
                }}
              >
                <Image
                  preview={false}
                  src={ArticleImage}
                  alt="Social Card "
                />
              </div>
            ) : null
        }
        <div className={classNames('text-area')}>
          <UserSocialInfoCard
            retweet={tweetData.tweetType === 'about'}
            tweetData={tweetData}
            SocialType={SocialType}
            linkedInData={linkedinData}
            companyId={companyId}
            companyName={companyName}
          />
          <div className={classNames('parser-data-drop text-truncate-one-line')}>
            {SocialType === 'linkedin' && linkedinData?.description ? parser(linkedinData?.description) : parser(tweetData.tweet)}
          </div>
          <div className="bottom">
            <h5 className="parser-data-drop time-heading">{time}</h5>
            <div
              className="share-tweet"
              aria-hidden="true"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Popover
                placement="left"
                content={content}
                trigger="click"
                getPopupContainer={(e: HTMLElement) => e}
                className="popover-sharing-custom line-block"
              >
                <div
                  className="share-tweet"
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <ShareArticleIcon />
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </SocialListCardWrapper>
    ) : (
      <SocialCardWrapper
        onClick={openArticle}
        onKeyPress={openArticle}
        role="button"
        aria-label="Open article"
        tabIndex={0}
        className={classNames('article-item article-tile-global', { heroView: heroArticle })}
      >
        {
          ArticleImage?.length && videoUrl === '' ? (
            <div
              ref={elementRef}
              className="profile-area"
              style={{
                position: 'relative',
              }}
            >
              {ArticleImage.includes('.gif') ? <img src={ArticleImage} alt="Social Card " /> : (
                <Image
                  preview={false}
                  src={setImageSize(
                    ArticleImage,
                    refWidth || articleWidth,
                    refHeight || articleHeight,
                    articleId,
                  )}
                  alt="Social Card "
                />
              )}
            </div>
          ) : null
        }
        {
          videoUrl?.length && ArticleImage?.length
            ? (
              <div
                className="profile-area"
                style={{
                  position: 'relative',
                }}
              >
                <Iframe
                  url={videoUrl}
                  width="100%"
                  height="280px"
                  id="videoFrameId"
                  className="videoFrame"
                  display="block"
                  position="relative"
                  scrolling="no"
                  frameBorder={0}
                />
              </div>
            ) : null
        }
        <div className="text-area">
          <UserSocialInfoCard
            retweet={tweetData.tweetType === 'about'}
            tweetData={tweetData}
            SocialType={SocialType}
            linkedInData={linkedinData}
            companyId={companyId}
            companyName={companyName}
          />
          <div className="parser-data-drop">
            {SocialType === 'linkedin' && linkedinData?.description ? parser(linkedinData?.description) : parser(tweetData.tweet)}
          </div>
          <div className="bottom">
            <h5 className="time-heading">{time}</h5>
            <div
              className="share-tweet"
              aria-hidden="true"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Popover
                placement="left"
                content={content}
                trigger="click"
                getPopupContainer={(e: HTMLElement) => e}
                className="popover-sharing-custom line-block"
              >
                <div
                  className="share-tweet"
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <ShareArticleIcon />
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </SocialCardWrapper>
    )
  );
};

SocialCard.defaultProps = defaultProps;
export default SocialCard;
